/**
 * В проекте изначально не использовался, так как
 * не изолируются потомки svg контейнера в стилях
 * и добавлен он впоследствии - со временем можно добавлять и его функциональность
 */

export default {
  name: 'BaseIcon',
  
  inheritAttrs: false,

  props: {
    name: {
      type: String,
      required: true,
    },
  },
}